import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "112vh",
    width: "100%",
    backgroundImage: `url("/assets/images/login_icons/BannerBg.png")`,
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    position: "relative",
    paddingRight: "5.5%",
    paddingLeft: "5.5%",
    boxSizing: "border-box",
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
      padding: "24px 16px",
      height: "auto",
      minHeight: "100vh",
      overflowY: "auto",
    },
  },

  heroBranding: {
    position: "absolute",
    top: "42px",
    left: "123px !important ",
    zIndex: 10,
    userSelect: "none",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },

  heroTagline: {
    fontFamily: "'Poppins', 'Inter', sans-serif !important",
    fontSize: "21px !important",
    fontWeight: "500 !important",
    color: "#111827 !important",
    lineHeight: "1.25 !important",
    letterSpacing: "-0.01em",
  },

  heroTitle: {
    fontFamily: "'Poppins', 'Inter', sans-serif !important",
    fontSize: "48px !important",
    fontWeight: "900 !important",
    color: "#000000 !important",
    lineHeight: "1.05 !important",
    letterSpacing: "-0.035em !important",
    textTransform: "uppercase",
    marginTop: "2px",
  },

  loginCard: {
    background: "#ffffff",
    borderRadius: "32px",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.12), 0 0 1px 1px rgba(0, 0, 0, 0.04)",
    border: "1px solid rgba(226, 232, 240, 0.8)",
    padding: "46px 44px 38px 44px",
    width: "100%",
    maxWidth: "540px",
    boxSizing: "border-box",
    zIndex: 10,
    [theme.breakpoints.down("sm")]: {
      padding: "28px 18px 24px 18px",
      borderRadius: "20px",
      maxWidth: "100%",
    },
  },

  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "4px",
    width: "100%",
  },

  logoImg: {
    width: "220px",
    height: "38px",
    objectFit: "contain",
    display: "block",
  },

  cardSubtitle: {
    textAlign: "center",
    fontSize: "13.5px !important",
    color: "#64748b !important",
    fontWeight: "500 !important",
    letterSpacing: "-0.01em",
    marginTop: "5px !important",
  },

  brandHighlight: {
    color: "#0f172a",
    fontWeight: 700,
  },

  dividerWrapper: {
    display: "flex",
    alignItems: "center",
    margin: "24px 0 20px 0",
    width: "100%",
  },

  dividerLine: {
    flex: 1,
    height: "1px",
    backgroundColor: "#e2e8f0",
  },

  dividerText: {
    padding: "0 12px",
    fontSize: "11.5px !important",
    fontWeight: "700 !important",
    letterSpacing: "1px !important",
    color: "#64748b !important",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  },

  sectionLabel: {
    fontSize: "11.5px !important",
    fontWeight: "700 !important",
    letterSpacing: "0.6px !important",
    color: "#64748b !important",
    textTransform: "uppercase",
    marginBottom: "10px !important",
    display: "block",
  },

  rolePillButton: {
    height: "40px !important",
    borderRadius: "50px !important",
    textTransform: "none !important",
    fontSize: "12.5px !important",
    fontWeight: "600 !important",
    padding: "6px 12px !important",
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
    gap: "6px",
    transition: "all 0.18s ease-in-out !important",
    whiteSpace: "nowrap",
  },

  foodAdminButton: {
    height: "40px !important",
    borderRadius: "50px !important",
    textTransform: "none !important",
    fontSize: "12.5px !important",
    fontWeight: "600 !important",
    padding: "6px 18px !important",
    display: "inline-flex !important",
    alignItems: "center !important",
    gap: "7px",
    border: "1px solid #e2e8f0 !important",
    backgroundColor: "#ffffff !important",
    color: "#1e293b !important",
    transition: "all 0.18s ease-in-out !important",
    "&:hover": {
      backgroundColor: "#f8fafc !important",
      borderColor: "#cbd5e1 !important",
    },
  },

  foodAdminActive: {
    backgroundColor: "#000000 !important",
    borderColor: "#000000 !important",
    color: "#ffffff !important",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15) !important",
    "&:hover": {
      backgroundColor: "#1a1a1a !important",
      borderColor: "#000000 !important",
    },
  },

  fieldLabelRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "7px",
  },

  inputField: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      height: "48px",
      borderRadius: "12px",
      backgroundColor: "#ffffff",
      fontSize: "14px",
      fontFamily: "'Inter', 'Poppins', sans-serif",
      "& fieldset": {
        borderColor: "#e2e8f0",
      },
      "&:hover fieldset": {
        borderColor: "#cbd5e1",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#000000",
        borderWidth: "1.5px",
      },
    },
    "& .MuiInputBase-input": {
      padding: "12px 14px 12px 0",
      color: "#1e293b",
      "&::placeholder": {
        color: "#94a3b8",
        opacity: 0.8,
        fontSize: "13.5px",
      },
    },
    "& .MuiFormHelperText-root": {
      marginLeft: "2px",
      marginTop: "3px",
      fontSize: "11px",
    },
  },

  passwordToggle: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    color: "#64748b",
    fontSize: "12px",
    fontWeight: 600,
    userSelect: "none",
    transition: "color 0.15s ease",
    "&:hover": {
      color: "#0f172a",
    },
  },

  optionsRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "12px",
    marginBottom: "22px",
  },

  rememberLabel: {
    fontSize: "13.5px !important",
    color: "#475569 !important",
    fontWeight: "500 !important",
    userSelect: "none",
  },

  forgotPasswordLink: {
    fontSize: "13.5px !important",
    color: "#0284c7 !important",
    fontWeight: "600 !important",
    cursor: "pointer",
    display: "flex !important",
    alignItems: "center !important",
    gap: "4px",
    userSelect: "none",
    transition: "color 0.15s ease",
    "&:hover": {
      color: "#0369a1 !important",
      textDecoration: "underline",
    },
  },

  submitButton: {
    height: "50px !important",
    borderRadius: "12px !important",
    backgroundColor: "#000000 !important",
    color: "#ffffff !important",
    fontSize: "14.5px !important",
    fontWeight: "600 !important",
    textTransform: "none !important",
    letterSpacing: "0.2px",
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
    gap: "8px",
    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.18) !important",
    transition: "all 0.2s ease-in-out !important",
    "&:hover": {
      backgroundColor: "#1f2937 !important",
      boxShadow: "0 6px 18px rgba(0, 0, 0, 0.25) !important",
      transform: "translateY(-1px)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
  },
}));

export default useStyles;
